import styled from 'styled-components';

export const AddressStyles = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 2;
  align-items: flex-end;
  font-size: ${({ theme }) => theme.fontSize.nm};
  color: ${({ theme }) => theme.colors.footer_headings};
  margin-top: 13px;

  .favorites {
    padding-bottom: 15px;
  }

  @media (max-width: 512px) {
    margin-top: 9px;
    font-size: ${({ theme }) => theme.fontSize.sm};
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AdressRow = styled.div`
  padding-bottom: 15px;
  margin-right: auto;
  display: flex;

  .text {
    margin-left: 5px;
  }
`;

export const DeletedMessage = styled.div`
  color: ${({ theme }) => theme.colors.color_red};
  padding-bottom: 15px;
`;

export const DateAndViewsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  padding-bottom: 15px;
  @media (max-width: 512px) {
    flex-direction: row;
  }
`;
